import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import _ from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/*Actions*/
import {
	createPriceTemplate,
	updatePriceTemplate,
	savePriceTemplates,
	exportProducts,
	getMessages
} from '../../../redux/actions';

/*Dialogs*/
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

class CreateNewTemplate extends Component {
	constructor(props) {
        super(props);
        this.state = {
			isCreateTemplateServiceCompleted: false,
			isExportProductsServiceCompleted: false,
			exportOperation: '',
			errorMessage: '',
			allpricingChecked: false,
			allproductChecked: false,

			allProductLineAndBrandsChecked: false,
			allGEProfileChecked: false,
			allHaierChecked: false,
			allCafeChecked: false,
			allHotpointChecked: false,
			allMonogramChecked: false,

			isTodayPriceChecked: true,	// TO DO: For now set default checked
			isFuturePriceChecked: false,

			date: '',
			payload: {
				templateName: '',
				accountNumber: '', //Set
				priceOptions: ["Sales Agreement Number", "Sales Agreement Name", "Net Price"], //Set
                productOptions: ["Item Number", "Product Line"], //Set,
				productLines: {}
			},

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			allProductLinesAndBrandsList: [
				"GE/GE Profile", "Cafe", "Hotpoint", "Haier", "Monogram"
			],
			message:[],
			allProductLinesAndBrands: {
				"GE/GE Profile": [
					{
						label: "Dishwashers",
						value: "Dishwashers",
						checked: false
					}, {
						label: "Disposers & Compactors",
						value: "Disposers & Compactors",
						checked: false
					}, {
						label: "Washers & Dryers",
						value: "Washers & Dryers",
						checked: false
					}, {
						label: "Cooktops",
						value: "Cooktops",
						checked: false
					}, {
						label: "Microwave Ovens",
						value: "Microwave Ovens",
						checked: false
					}, {
						label: "Ranges",
						value: "Ranges",
						checked: false
					}, {
						label: "Speedcooking Ovens",
						value: "Speedcooking Ovens",
						checked: false
					}, {
						label: "Venting Systems & Hoods",
						value: "Venting Systems & Hoods",
						checked: false
					}, {
						label: "Wall Ovens",
						value: "Wall Ovens",
						checked: false
					}, {
						label: "Warming Drawers",
						value: "Warming Drawers",
						checked: false
					}, {
						label: "Air Purifiers",
						value: "Air Purifiers",
						checked: false
					}, {
						label: "Dehumidifiers",
						value: "Dehumidifiers",
						checked: false
					}, {
						label: "Room Air Conditioners",
						value: "Room Air Conditioners",
						checked: false
					}, {
						label: "Water Filters & Softeners",
						value: "Water Filters & Softeners",
						checked: false
					}, {
						label: "Water Heaters",
						value: "Water Heaters",
						checked: false
					}, {
						label: "Freezers",
						value: "Freezers",
						checked: false
					}, {
						label: "Icemakers",
						value: "Icemakers",
						checked: false
					}, {
						label: "Refrigerators",
						value: "Refrigerators",
						checked: false
					}, {
						label: "Wine Reserves & Beverage Centers",
						value: "Wine Reserves & Beverage Centers",
						checked: false
					}, {
						label: "Small Appliances",
						value: "Small Appliances",
						checked: false
					},  {
						label: "HVAC",
						value: "HVAC",
						checked: false
					}
				],
				"Cafe": [
					{
						label: "Ranges",
						value: "Ranges",
						checked: false
					}, {
						label: "Refrigerators",
						value: "Refrigerators",
						checked: false
					}, {
						label: "Dishwashers",
						value: "Dishwashers",
						checked: false
					}, {
						label: "Speedcooking Ovens",
						value: "Speedcooking Ovens",
						checked: false
					}, {
						label: "Wall Ovens",
						value: "Wall Ovens",
						checked: false
					}, {
						label: "Cooktops",
						value: "Cooktops",
						checked: false
					}, {
						label: "Venting Systems & Hoods",
						value: "Venting Systems & Hoods",
						checked: false
					}, {
						label: "Microwave Ovens",
						value: "Microwave Ovens",
						checked: false
					}, {
						label: "Wine Reserves & Beverage Centers",
						value: "Wine Reserves & Beverage Centers",
						checked: false
					}, {
						label: "Warming Drawers",
						value: "Warming Drawers",
						checked: false
					}, {
						label: "Small Appliances",
						value: "Small Appliances",
						checked: false
					}
				],
				"Hotpoint": [
					{
						label: "Ranges",
						value: "Ranges",
						checked: false
					}, {
						label: "Refrigerators",
						value: "Refrigerators",
						checked: false
					}, {
						label: "Dishwashers",
						value: "Dishwashers",
						checked: false
					}, {
						label: "Microwave Ovens",
						value: "Microwave Ovens",
						checked: false
					}, {
						label: "Washers & Dryers",
						value: "Washers & Dryers",
						checked: false
					}, {
						label: "Freezers",
						value: "Freezers",
						checked: false
					}, {
						label: "Room Air Conditioners",
						value: "Room Air Conditioners",
						checked: false
					}
				],
				"Haier": [
					{
						label: "Dishwashers",
						value: "Dishwashers",
						checked: false
					}, {
						label: "Washers & Dryers",
						value: "Washers & Dryers",
						checked: false
					}, {
						label: "Microwave Ovens",
						value: "Microwave Ovens",
						checked: false
					}, {
						label: "Ranges",
						value: "Ranges",
						checked: false
					}, {
						label: "Refrigerators",
						value: "Refrigerators",
						checked: false
					}, {
						label: "Room Air Conditioners",
						value: "Room Air Conditioners",
						checked: false
					}, {
						label: "Cooktops",
						value: "Cooktops",
						checked: false
					}, {
						label: "Wall Ovens",
						value: "Wall Ovens",
						checked: false
					}, {
						label: "Venting Systems & Hoods",
						value: "Venting Systems & Hoods",
						checked: false
					}, {
						label: "Wine Reserves & Beverage Centers",
						value: "Wine Reserves & Beverage Centers",
						checked: false
					}, {
						label: "Dehumidifiers",
						value: "Dehumidifiers",
						checked: false
					},  {
						label: "HVAC",
						value: "HVAC",
						checked: false
					}
				],
				"Monogram": [
					{
						label: "Refrigerators",
						value: "Refrigerators",
						checked: false
					}, {
						label: "Icemakers",
						value: "Icemakers",
						checked: false
					}, {
						label: "Wine Reserves & Beverage Centers",
						value: "Wine Reserves & Beverage Centers",
						checked: false
					}, {
						label: "Freezers",
						value: "Freezers",
						checked: false
					}, {
						label: "Cooktops",
						value: "Cooktops",
						checked: false
					}, {
						label: "Ranges",
						value: "Ranges",
						checked: false
					}, {
						label: "Speedcooking Ovens",
						value: "Speedcooking Ovens",
						checked: false
					}, {
						label: "Wall Ovens",
						value: "Wall Ovens",
						checked: false
					}, {
						label: "Microwave Ovens",
						value: "Microwave Ovens",
						checked: false
					}, {
						label: "Warming Drawers",
						value: "Warming Drawers",
						checked: false
					}, {
						label: "Venting Systems & Hoods",
						value: "Venting Systems & Hoods",
						checked: false
					}, {
						label: "Grills",
						value: "Grills",
						checked: false
					}, {
						label: "Dishwashers",
						value: "Dishwashers",
						checked: false
					}, {
						label: "Disposers & Compactors",
						value: "Disposers & Compactors",
						checked: false
					}, {
						label: "Small Appliances",
						value: "Small Appliances",
						checked: false
					}
				]
			},
			allProductAndPricingInformation: {
				pricing: [{
					label: "Sales Agreement Number",
					value: "Sales Agreement Number",
					type: "salesAgreementNumber",
					checked: true
				}, {
					label: "Sales Agreement Name",
					value: "Sales Agreement Name",
					type: "salesAgreementName",
					checked: true
				}, {
					label: "MSRP",
					value: "MSRP",
					type: "price",
					checked: false
				}, {
					label: "MAP",
					value: "MAP",
					type: "price",
					checked: false
				}, {
					label: "Promo MAP",
					value: "Promo MAP",
					type: "price",
					checked: false
				}, {
					label: "Estimated Low Resell",
					value: "Estimated Low Resell",
					type: "price",
					checked: false
				}, {
					label: "List Price",
					value: "List Price",
					type: "price",
					checked: false
				}, {
					label: "All Price Details",
					value: "All Price Details",
					type: "discount",
					checked: false
				}, {
					label: "Net Price",
					value: "Net Price",
					type: "price",
					checked: true
				}],
				product: [{
					label: "Item Number",
					value: "Item Number",
					checked: true,
					disabled: true
				}, {
					label: "UPC Code",
					value: "UPC Code",
					checked: false
				}, {
					label: "Brand",
					value: "Brand",
					checked: false
				}, {
					label: "Color",
					value: "Color",
					checked: false
				}, {
					label: "Product Line",
					value: "Product Line",
					checked: true,
					disabled: true
				}, {
					label: "Product Category",
					value: "Product Category",
					checked: false
				}, {
					label: "Description",
					value: "Description",
					checked: false
				}, {
					label: "ADA Compliant",
					value: "ADA Compliant",
					checked: false
				}, {
					label: "Produced In America",
					value: "Produced In America",
					checked: false
				}, {
					label: "EStar Qualified",
					value: "EStar Qualified",
					checked: false
				}, {
					label: "Availability",
					value: "Availability",
					checked: false
				}, {
					label: "Next Avail",
					value: "Next Avail",
					checked: false,
				}, {
					label: "ETA",
					value: "ETA",
					checked: false,
				}, {
					label: "Replacement Model",
					value: "Replacement Model",
					checked: false
				}, {
					label: "Load Points",
					value: "Load Points",
					checked: false
				}, {
					label: "Carton Dimensions",
					value: "Carton Dimensions",
					checked: false
				}, {
					label: "Shipping Weight",
					value: "Shipping Weight",
					checked: false
				},
				{
                    label: "Cabinet Width",
                    value: "Cabinet Width",
                    checked: false,
                },
                {
                    label: "Overall Height",
                    value: "Overall Height",
                    checked: false,
                },
                {
                    label: "Overall Width",
                    value: "Overall Width",
                    checked: false,
                },
                {
                    label: "Overall Depth",
                    value: "Overall Depth",
                    checked: false,
                },
			]
			}
		}
		// this.handleChange = this.handleChange.bind(this);
		this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
		this.callBackAfterCreateEditPriceTemplate = this.callBackAfterCreateEditPriceTemplate.bind(this);
		this.getDemadClassforAgreement = this.getDemadClassforAgreement.bind(this);
    }

	handleGenericDialogStatus(flag) {
		this.setState({
			showGenericOverlayDialog: flag
		});
		browserHistory.push('/saved-exports');
	}

	resetState(event) {
		var allProductLinesAndBrands = this.state.allProductLinesAndBrands,
			allProductAndPricingInformation = this.state.allProductAndPricingInformation;
		this.state.allProductLinesAndBrandsList.map((item, index) => {
			allProductLinesAndBrands[item].map((itm, ind) => {
				itm.checked = false;
				return null;
			})
			return null;
		})
		allProductAndPricingInformation.pricing.map((item, index) => {
			item.checked = false;
			return null;
		})
		allProductAndPricingInformation.product.map((item, index) => {
			item.checked = false;
			return null;
		})
		this.setState({
			errorMessage: '',
			allpricingChecked: false,
			allproductChecked: false,

			allProductLineAndBrandsChecked: false,
			allGEProfileChecked: false,
			allHaierChecked: false,
			allCafeChecked: false,
			allHotpointChecked: false,
			allMonogramChecked: false,
			isTodayPriceChecked: true,	// set default state true
			isFuturePriceChecked: false,
			date: '',
			payload: {
				templateName: '',
				accountNumber: '', //Set
				priceOptions: [], //Set
				productOptions: [], //Set,
				productLines: {}
			},
			allProductLinesAndBrands: allProductLinesAndBrands,
			allProductAndPricingInformation: allProductAndPricingInformation
		});
		browserHistory.push("/saved-exports");
	}

	componentWillMount() {
		const self = this;
		const today = moment();
		self.props.getMessages(`accountNumber=${self.props.state.user.accountDetail.responseObject[0].ACCOUNTNUMBER}`, true, response => {
				if (response.status && response.responseObject) {
					const filteredMessages = response.responseObject.filter(message => {
						const startDate = moment(message.start_date);
						const endDate = moment(message.end_date);
						return startDate <= today <= endDate;
					});
					self.setState({
						message: filteredMessages
					});
				}
			});
	}


	componentDidMount() {
		var self = this,
			typeOfOperation = self.props.params.typeOfOperation;
		let pricing = self.state.allProductAndPricingInformation.pricing;
		if(self.props.getSelectedAccountType() !== "RETAIL") {
			pricing = self.state.allProductAndPricingInformation.pricing.filter(item => item.value !== "All Price Details");
		}
		self.setState({
			exportOperation: typeOfOperation,
			allProductAndPricingInformation: {
				...this.state.allProductAndPricingInformation,
				pricing
			}
		}, () => {
			if(typeOfOperation === 'edit') {
				if(!self.props.state.exports.editTemplatePayload) {
					browserHistory.push("/saved-exports");
				} else {
					// var date = '';
					// if(self.props.state.exports.editTemplatePayload && self.props.state.exports.editTemplatePayload.futurePrice) {
					// 	date = moment(self.props.state.exports.editTemplatePayload.futurePrice);
					// }
					var payload = self.props.state.exports.editTemplatePayload,
						allProductAndPricingInformation = self.state.allProductAndPricingInformation,
						allProductLinesAndBrands = self.state.allProductLinesAndBrands;

					self.state.allProductLinesAndBrandsList.map((item, index) => {
						if(payload.productLines && payload.productLines[item]) {
							var currProductLineItem = allProductLinesAndBrands[item];
							currProductLineItem.map((itm, ind) => {
								if(payload.productLines[item].indexOf(itm.value) !== -1) {
									itm.checked = true;
								}
								return null;
							})
						}
						return null;
					});
					//Checked default value is present or not
					payload.priceOptions && allProductAndPricingInformation.pricing.map((item, index) => {
						if(payload.priceOptions.indexOf(item.value) !== -1) {
							item.checked = true;
						}
						return null;
					});
					//Checked default value is present or not
					payload.productOptions && allProductAndPricingInformation.product.map((item, index) => {
						if(payload.productOptions.indexOf(item.value) !== -1) {
							item.checked = true;
						}
						return null;
					});

					//Update state with updated values
					self.setState({
						// date: date,
						payload: payload,
						allProductAndPricingInformation: allProductAndPricingInformation,
						allProductLinesAndBrands: allProductLinesAndBrands,

						allpricingChecked: _.find(allProductAndPricingInformation.pricing, ["checked", false])?false:true,
						allproductChecked: _.find(allProductAndPricingInformation.product, ["checked", false])?false:true,

						allGEProfileChecked: _.find(allProductLinesAndBrands["GE/GE Profile"], ["checked", false])?false:true,
						allHaierChecked: _.find(allProductLinesAndBrands["Haier"], ["checked", false])?false:true,
						allCafeChecked: _.find(allProductLinesAndBrands["Cafe"], ["checked", false])?false:true,
						allHotpointChecked: _.find(allProductLinesAndBrands["Hotpoint"], ["checked", false])?false:true,
						allMonogramChecked: _.find(allProductLinesAndBrands["Monogram"], ["checked", false])?false:true,

						isTodayPriceChecked: true, // self.props.state.exports.editTemplatePayload.todaysPrice != null?true:false,
						// isFuturePriceChecked: self.props.state.exports.editTemplatePayload.futurePrice != null?true:false
					}, () => {
						self.setState({
							allProductLineAndBrandsChecked: self.state.allGEProfileChecked && self.state.allHaierChecked && self.state.allCafeChecked && self.state.allHotpointChecked && self.state.allMonogramChecked?true:false
						})
					});
				}
			} else if(typeOfOperation === 'new' || typeOfOperation === 'edit') {

			} else {
				browserHistory.push('/price-template/new');
			}
		});
	}

	// handleChangeRaw(value) {
	// 	this.setState({
	// 		errorMessage: '',
	// 		isFuturePriceChecked: true
	// 	})
	// 	this.handleChange(moment(value));
	// }
	handleChange(date) {
	  	var self = this;
	  	self.setState({
		  	date: date.isValid()? date :self.state.payload.date,
			errorMessage: '',
		  	payload: {
			  	...self.state.payload,
			  	futurePrice: date && date.format('MM/DD/YYYY')
		  	},
			isFuturePriceChecked: true
	  	});
	}
	onChangeUpdateParam(paramName, event) {
		var self = this,
			paramValue = event.target.value;

		if(paramName === "todaysPrice") {
			if(event.target.checked) {
				paramValue = new Date();
				paramValue = (paramValue.getMonth() + 1) +"/" + paramValue.getDate() + "/" + paramValue.getFullYear();
			} else {
				paramValue = "";
			}
			self.setState({
				isTodayPriceChecked:  event.target.checked,
				isFuturePriceChecked : false,
			});
		} else if(paramName === 'futurePrice') {
			var payload = self.state.payload;
			if(!event.target.checked) delete payload.futurePrice;
			self.setState({
				date: event.target.checked?self.state.payload.date:'',
			  	payload: payload,
				isFuturePriceChecked:  event.target.checked,
				isTodayPriceChecked : false
			});
		}

		if(paramName !== "futurePrice") {
			var payload = {
				...self.state.payload,
				[paramName]: paramValue
			}
			if(self.state.isTodayPriceChecked) {
				delete payload.futurePrice;
			}
			self.setState({
				payload: payload
			});
		}
	}
	handleAllCheckBox(whichObj, paramName, event) {
		var obj = this.state.allProductAndPricingInformation[whichObj],
			arrayList = [];
		const isPriceDiscountAccess = this.props.isResponsibilityExists("Price Discounts");
		obj.map((item, index) => {
			if(whichObj === 'pricing') {
				if(item.type === 'discount' && !isPriceDiscountAccess) return null;
				if(item.value === 'MAP' && !this.props.isAccessToMAPGuidelines) return null;
				if(item.value === 'Promo MAP' && !this.props.isAccessToMAPGuidelines) return null;
			}
			if (item.disabled) {
				arrayList.push(item.value);
                return null;
            }
			item.checked = event.target.checked;
			if(event.target.checked) arrayList.push(item.value);
			return null;
		});
		this.setState({
			errorMessage: '',
			payload: {
				...this.state.payload,
				[paramName]: arrayList
			},
			allProductAndPricingInformation: {
				...this.state.allProductAndPricingInformation,
				[whichObj]: obj
			},
			["all"+whichObj+"Checked"]: event.target.checked
		})
	}
	handleSubcheckboxChange(whichObj, paramName, paramValue,  event) {
		var obj = this.state.allProductAndPricingInformation[whichObj],
			arrayList = this.state.payload[paramName];
		obj.map((item, index) => {
			if(item.value === paramValue) {
				item.checked = event.target.checked;
				event.target.checked?arrayList.push(item.value):arrayList.splice(arrayList.indexOf(item.value), 1);
			}
			return null;
		});
		this.setState({
			errorMessage: '',
			payload: {
				...this.state.payload,
				[paramName]: arrayList
			},
			allProductAndPricingInformation: {
				...this.state.allProductAndPricingInformation,
				[whichObj]: obj
			},
			["all"+whichObj+"Checked"]: (!event.target.checked?false:this.state["all"+whichObj+"Checked"])
		})
	}
	handleAllProductLineAndBrandsCheckBox(event) {
		var self = this,
			payload = this.state.payload,
			allProductLinesAndBrands = this.state.allProductLinesAndBrands;
		self.setState({allProductLineAndBrandsChecked: event.target.checked});
		self.state.allProductLinesAndBrandsList.map((item, index) => {
			var whichObj = item,
				paramName = "productLines",
				obj = this.state.allProductLinesAndBrands[whichObj],
				arrayList = [],
				checked = event.target.checked;
			obj.map((item, index) => {
				item.checked = checked;
				if(checked) arrayList.push(item.value);
				return null;
			});
			payload = {
				...payload,
				[paramName]: {
					...payload[paramName],
					[whichObj]: arrayList
				}
			};
			allProductLinesAndBrands = {
				...allProductLinesAndBrands,
				[whichObj]: obj
			};
			this.setState({
				["all"+whichObj.replace(/ /g, '')+"Checked"]: checked
			})
			return null;
		});
		this.setState({
			errorMessage: '',
			payload: payload,
			allProductLinesAndBrands: allProductLinesAndBrands
		});
	}
	handleAllProductLineHeadingCheckBox(whichObj, paramName, event) {
		var obj = this.state.allProductLinesAndBrands[whichObj],
			arrayList = [],
			checked = event.target.checked;
		obj.map((item, index) => {
			item.checked = checked;
			if(checked) arrayList.push(item.value);
			return null;
		});
		this.setState({
			errorMessage: '',
			payload: {
				...this.state.payload,
				[paramName]: {
					...this.state.payload[paramName],
					[whichObj]: arrayList
				}
			},
			allProductLinesAndBrands: {
				...this.state.allProductLinesAndBrands,
				[whichObj]: obj
			},
			["all"+whichObj.replace(/ /g, '')+"Checked"]: checked,
			allProductLineAndBrandsChecked: !checked?false:this.state.allProductLineAndBrandsChecked
		})
	}
	handleProductLineSubcheckboxChange(whichObj, paramName, paramValue,  event) {
		var obj = this.state.allProductLinesAndBrands[whichObj],
			arrayList = this.state.payload[paramName][whichObj];
		arrayList = !arrayList?[]:arrayList;
		obj.map((item, index) => {
			if(item.value === paramValue) {
				item.checked = event.target.checked;
				event.target.checked?arrayList.push(item.value):arrayList.splice(arrayList.indexOf(item.value), 1);
			}
			return null;
		});
		this.setState({
			errorMessage: '',
			payload: {
				...this.state.payload,
				[paramName]: {
					...this.state.payload[paramName],
					[whichObj]: arrayList
				}
			},
			allProductLinesAndBrands: {
				...this.state.allProductLinesAndBrands,
				[whichObj]: obj
			},
			["all"+whichObj.replace(/ /g, '')+"Checked"]: (!event.target.checked?false:this.state["all"+whichObj.replace(/ /g, '')+"Checked"]),
			allProductLineAndBrandsChecked: !event.target.checked?false:this.state.allProductLineAndBrandsChecked
		})
	}
	handleExportInfo(typeOfOperation, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			errorMessage: ''
		});

		let geProfile = _.filter(this.state.allProductLinesAndBrands["GE/GE Profile"],["checked", true]).length;
		let cafe = _.filter(this.state.allProductLinesAndBrands["Cafe"],["checked", true]).length;
		let hotpoint = _.filter(this.state.allProductLinesAndBrands["Hotpoint"],["checked", true]).length;
		let monogram = _.filter(this.state.allProductLinesAndBrands["Monogram"],["checked", true]).length;
		let haier = _.filter(this.state.allProductLinesAndBrands["Haier"],["checked", true]).length;
		//Check atlest one item is selected from product brand
		if(geProfile === 0 && cafe === 0 && hotpoint === 0  && monogram === 0 && haier === 0){
			self.setState({
				errorMessage: "Please select at least one item from product brands"
			});
			window.scrollTo(0, 0);
		} else if(self.state.payload.priceOptions.length === 0 && self.state.payload.productOptions.length === 0) {
			self.setState({
				errorMessage: "Please select at least one item from price or product"
			});
			window.scrollTo(0, 0);
		}
		//Check if future or today's date is selected
		else if(this.state.isFuturePriceChecked && !this.state.date) {
			self.setState({
				errorMessage: "Please select future date"
			});
			window.scrollTo(0, 0);
		}
		
		//Check if template name is entered in case of save template check box is marked
		else if(self.state.exportOperation === 'new' && self.saveTemplateCheckbox && self.saveTemplateCheckbox.checked && !self.state.payload.templateName) {
			self.setState({
				errorMessage: "Please enter template name.",
			});
			window.scrollTo(0, 0);
		}
		//check with edit operation
		else if(self.state.exportOperation === 'edit' && !self.state.payload.templateName) {
			self.setState({
				errorMessage: "Please enter template name.",
			});
			window.scrollTo(0, 0);
		}
		else {
			let payload = self.state.payload;
			//remove priceoptions in case of not prices access from prepared payload
			if(!self.props.isResponsibilityExists("Price")) {
				delete payload.priceOptions;
			}
			//remove futurePrice in case of checkbox is not checked from prepared payload
			// if(self.futurePriceCheckbox && !self.futurePriceCheckbox.checked) {
			// 	delete payload.futurePrice;
			// }
			//remove template name if it is blank
			if(self.saveTemplateCheckbox && !self.saveTemplateCheckbox.checked) {
				delete payload.templateName
			}
			//remove todays price if it is blank
			if(payload.todaysPrice === "") {
				delete payload.todaysPrice
			}
			const { userDetails, selectedAccount, selectedPriceSource } = self.props.state.user;
			const demandClass = this.getDemadClassforAgreement(selectedPriceSource.AGREEMENT_NUMBER.toString());
			const selectedAccountsAllPriceSources = this.props.getSalesAgreementList();
			let quoteType = '';
			if(selectedPriceSource && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
				const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === selectedPriceSource.AGREEMENT_NUMBER);
				quoteType = data && data["Quote Type"] ? data["Quote Type"].toLowerCase() : '';			
			}
			let messageQuoteType = self.state.message && self.state.message.length >0 ? self.state.message[0].message_description : "";
			payload = {
				...payload,
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				salesAgreementNumber: selectedPriceSource.AGREEMENT_NUMBER.toString(),
				salesAgreementName: selectedPriceSource.AGREEMENT_NAME,
				userId: userDetails.sso,
				emailId: userDetails.email,
				zip: self.props.getZipCode(),
				demandClass: demandClass,
				message_description: quoteType && quoteType =="n"?messageQuoteType:""
			}
			if((self.saveTemplateCheckbox && self.saveTemplateCheckbox.checked === true) || typeOfOperation === 'PUT'){
				self.setState({
					isCreateTemplateServiceCompleted: false,
					isExportProductsServiceCompleted: false
				});
				if(typeOfOperation === 'POST') {
					self.props.createPriceTemplate(payload, response => {
						self.setState({
							isCreateTemplateServiceCompleted: true
						});
						self.callBackAfterCreateEditPriceTemplate(response, typeOfOperation);
					});
					self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
						payload = {
							...payload,
							topLoadIndicator: resp ? 'Y' : 'N'
						};
						const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
							if(resp && resp.agentid) {
								// Once run export will be working uncomment below line
								self.props.exportProducts(payload, `warehouseCode=${resp.agentid}`, response => {
									self.setState({
										isExportProductsServiceCompleted: true
									});
								});
							}
						});
					});
				} else {
					self.props.updatePriceTemplate(payload, response => {
						self.setState({
							isCreateTemplateServiceCompleted: true,
							isExportProductsServiceCompleted: true
						});
						self.callBackAfterCreateEditPriceTemplate(response, typeOfOperation);
					});
				}
			} else {
				self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
					payload = {
						...payload,
						topLoadIndicator: resp ? 'Y' : 'N'
					};
					const data = JSON.parse(self.props.state.user.selectedAddress);
					const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
					zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							self.props.exportProducts(payload, `warehouseCode=${this.props.state.user.selectedADC}`, response => {
								if(response.status) {
									self.setState({
										genericDialogHeading: "Report Generated",
										genericDialogText: "You will receive an email shortly with the report link.",
										modalButtons: "ok",
										showGenericOverlayDialog: false,
										isCreateTemplateServiceCompleted: true,
										isExportProductsServiceCompleted: true
									}, () => {
										self.setState({
											showGenericOverlayDialog: true
										});
									})
								} else {
									self.setState({
										errorMessage: response.responseMessage
									})
									window.scrollTo(0, 0);
								}
							});
						}
					});
				});
			}
		}
	}

	getDemadClassforAgreement(agreementNumber) {
		const self = this;
		const { selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
		let priceSourceDetails = JSON.parse(JSON.stringify(selectedPriceSource));
		if (agreementNumber) {
			priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER.toString() === agreementNumber.toString());
		}
		if (priceSourceDetails && priceSourceDetails["Demand Class"]) {
			return priceSourceDetails["Demand Class"];
		}
	}

	callBackAfterCreateEditPriceTemplate(response, typeOfOperation) {
		var self = this;
		let { state } = self.props;
		//Update store with new price template for saved brochure
		if(response.status) {
			//Update store with newly copied template
			var priceTemplates = state.exports.priceTemplates;
			if(typeOfOperation === 'POST' && priceTemplates) {
				priceTemplates.responseObject.push(response.responseObject);
			} else if(typeOfOperation === 'PUT' && priceTemplates) {
				state.exports.priceTemplates.responseObject.map((item, index) => {
					if(item.templateId === response.responseObject.templateId) {
						priceTemplates.responseObject[index] = response.responseObject;
					}
					return null;
				});
			}

			self.props.savePriceTemplates(priceTemplates);
			if(	typeOfOperation === 'POST') {
				self.setState({
					genericDialogHeading: "Report Generated",
					genericDialogText: "Template created successfully. You will receive an email shortly with the report link.",
					modalButtons: "ok",
					showGenericOverlayDialog: false
				}, () => {
					self.setState({
						showGenericOverlayDialog: true
					})
				});
			} else {
				self.setState({
					genericDialogHeading: "Template Updated",
					genericDialogText: "Template has been updated successfully.",
					modalButtons: "ok",
					showGenericOverlayDialog: false
				}, () => {
					self.setState({
						showGenericOverlayDialog: true
					})
				});
			}
			//browserHistory.push("/CustomerNet/viewexports");
		} else {
			self.setState({
				errorMessage: response.responseMessage
			})
			window.scrollTo(0, 0);
		}
	}
    render() {
		const isPricingAccess = this.props.isResponsibilityExists("Price");
		const isPriceDiscountAccess = this.props.isResponsibilityExists("Price Discounts");
		const selectedAccountsAllPriceSources = this.props.getSalesAgreementList();
		const {selectedPriceSource } = this.props.state.user;
		let quoteType = '';
		if(selectedPriceSource && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
			const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === selectedPriceSource.AGREEMENT_NUMBER);
			quoteType = data && data["Quote Type"] ? data["Quote Type"].toLowerCase() : '';			
		}
        return (
			<div>
            <div id="exportProductPriceInfoOverlayDialog">
				<h1 className="pageTitle push" style={{margin: '0.5em 0'}}>
					{this.state.exportOperation==='new'?"Export Product and Pricing Information":null}
					{this.state.exportOperation==='edit'?"Edit Saved Export Template":null}
				</h1>
				{quoteType && quoteType =="n" && this.state.message && this.state.message.length >0 ?<h1 className="pageQuoteMessage">{this.state.message[0].message_description}</h1>:""}
				<p className="red"><strong>{this.state.errorMessage}</strong></p>
				<form className="exportProductPriceInfoForm" name="exportProductPriceInfoForm" action="" onSubmit={(e) => e.preventDefault()}>
					{/* BEGIN OPTIONAL SECTION */}
					{this.state.exportOperation === 'edit'
						?<div className="push">
							<label style={{marginRight: '30px'}} htmlFor="editTemplateName"><strong>Template Name</strong></label>
							<input type="text" id="editTemplateName" defaultValue={this.state.payload.templateName} onChange={this.onChangeUpdateParam.bind(this, "templateName")} />
						</div>
						
						:null
					}
					{isPricingAccess && this.state.exportOperation === 'new'
						?<div className="priceDiv inline-datepicker-input">
							<strong>Show</strong>
							&nbsp;&nbsp;&nbsp;
							<label>
								<input type="radio" 
								name="showPriceDate"
								id="showTodaysPrice" 
								checked={this.state.isTodayPriceChecked}  
								onClick={this.onChangeUpdateParam.bind(this, "todaysPrice")} 
								defaultValue="todaysPrice" /> Today&#39;s Price
							</label>
							&nbsp;&nbsp;&nbsp;
							<label>
								<input type="radio" 
								name="showPriceDate" 
								id="showFuturePrice" 
								checked={this.state.isFuturePriceChecked} 
								onClick={this.onChangeUpdateParam.bind(this, "futurePrice")} 
								defaultValue="futurePrice" />Future Price
							</label>
							&nbsp;&nbsp;&nbsp;
							<DatePicker 
								minDate={moment()} 
								maxDate={moment().add(30, "days")} 
								disabled={!this.state.isFuturePriceChecked}
								placeholderText="(mm/dd/yyyy)" 
								selected={this.state.date} 
								onKeyDown={(e) => {	e.preventDefault(); }}
								onChange={this.handleChange.bind(this)} />
								&nbsp;&nbsp;&nbsp;
								<i>(date must be within 30 days)</i>
						</div>
						:null
					}
					{/* END OPTIONAL SECTION */}
					<p className="shaded">Select the product lines and brands to include in your export.</p>
					<div className="push">
						<p className="checkboxParagraph allPriceInformation" style={{width: 'auto'}}>
							<input checked={this.state.allProductLineAndBrandsChecked} onChange={this.handleAllProductLineAndBrandsCheckBox.bind(this)} className="selectAllCheckbox" type="checkbox" name="allProductLinesAndBrands_all" id="allProductLinesAndBrands_all" defaultValue="all" />
							<label htmlFor="allProductLinesAndBrands_all">All Product Lines & Brands</label>
						</p>
						{this.state.allProductLinesAndBrandsList.map((item, index) => {
							var subCheckBoxList = this.state.allProductLinesAndBrands[item];
							return <div style={{marginLeft: '2%', marginBottom: '5px'}} key={index}>
								<p className="checkboxParagraph allPriceInformation" style={{width: 'auto'}}>
									<input checked={this.state["all"+item.replace(/ /g, '')+"Checked"]} className="selectAllCheckbox" type="checkbox" onChange={this.handleAllProductLineHeadingCheckBox.bind(this, item, "productLines")} name={"productLineSubHeading_all"+index} id={"productLineSubHeading_all"+index} defaultValue="all" />
									<label htmlFor={"productLineSubHeading_all"+index} style={{fontWeight:'normal'}}>{item}</label>
								</p>
								{subCheckBoxList.map((itm, ind) => {
									return <p key={ind} className="checkboxParagraph individualOption priceInformation">
										<input type="checkbox" onChange={this.handleProductLineSubcheckboxChange.bind(this, item, "productLines", itm.value)} checked={itm.checked} id={"productLineAndBrands"+index+ind} defaultValue={itm.value} />
										<label htmlFor={"productLineAndBrands"+index+ind}>{itm.label}</label>
									</p>
								})}
							</div>
						})}
					</div>
					<p className="shaded">Select the information to include in your export.</p>
					{isPricingAccess
						?<div className="push">
							<p className="checkboxParagraph allPriceInformation">
								<input checked={this.state.allpricingChecked} onChange={this.handleAllCheckBox.bind(this, "pricing", "priceOptions")} className="selectAllCheckbox" type="checkbox" name="priceInfoToExport" id="priceInfoToExport_all" defaultValue="all" />
								<label htmlFor="priceInfoToExport_all">All Price Information</label>
							</p>
							{this.state.allProductAndPricingInformation.pricing.map((item, index) => {
								if(item.type === 'discount' && !isPriceDiscountAccess) return null;
								if(item.value === 'MAP' && !this.props.isAccessToMAPGuidelines) return null;
								if(item.value === 'Promo MAP' && !this.props.isAccessToMAPGuidelines) return null;
								return <p key={index} className="checkboxParagraph individualOption priceInformation">
									<input type="checkbox" onChange={this.handleSubcheckboxChange.bind(this, "pricing", "priceOptions", item.value)} checked={item.checked} disabled={item.disabled} name="priceInfoToExport" id={"priceInfoToExport"+index} defaultValue={item.value} />
									<label htmlFor={"priceInfoToExport"+index}>{item.label}</label>
								</p>
							})}
						</div>
						:null
					}
					<div id="productInformationDiv">
						<p className="checkboxParagraph allProductInformation">
							<input checked={this.state.allproductChecked} onChange={this.handleAllCheckBox.bind(this, "product", "productOptions")} className="selectAllCheckbox" type="checkbox" name="productInfoToExport" id="productInfoToExport_all" defaultValue="all" />
							<label htmlFor="productInfoToExport_all">All Product Information</label>
						</p>
						{this.state.allProductAndPricingInformation.product.map((item, index) => {
							return <p key={index} className="checkboxParagraph individualOption productInformation">
								<input type="checkbox" onChange={this.handleSubcheckboxChange.bind(this, "product", "productOptions", item.value)} checked={item.checked} disabled={item.disabled} name="productInfoToExport" id={"productInfoToExport"+index} defaultValue={item.value} />
								<label htmlFor={"productInfoToExport"+index}>{item.label}</label>
							</p>
						})}
					</div>
					{this.state.exportOperation === 'new'
						?<div>
					        <hr />
					        <p>
					          	<label><input type="checkbox" ref={(checkbx) => { this.saveTemplateCheckbox = checkbx }} name="saveExportAsTemplate" defaultValue="yes" /><b>Save Export as Template</b></label> &nbsp;
								<input type="text" name="templateName" onChange={this.onChangeUpdateParam.bind(this, "templateName")} placeholder="Enter Template Name" />
					        </p>
					        <hr />
				      	</div>
						:null
					}
					{this.state.exportOperation === 'edit'
						?<hr />
						:null
					}
					<div className="push">
						<div className="noButtonContainer" style={{marginTop: '1.5em', float: 'left'}}>
							<input onClick={this.resetState.bind(this)} type="reset" style={{marginTop: '0'}} className="noButton blueButton" value="Cancel"/>
						</div>
						<div className="yesButtonContainer" style={{marginTop: '1.5em', float: 'right'}}>
							{this.state.exportOperation === 'new'
								?<input style={{marginTop: '0'}} className="yesButton blueButton" onClick={this.handleExportInfo.bind(this, 'POST')} type="submit" id="exportInformation" value="Export Information" />
								:null
							}
							{this.state.exportOperation === 'edit'
								?<input style={{marginTop: '0'}} className="yesButton blueButton" onClick={this.handleExportInfo.bind(this, 'PUT')} type="submit" id="saveChanges" value="Save Changes" />
								:null
							}
						</div>
						<div style={{clear: 'both'}}></div>
					</div>
				</form>
				</div>
				{this.state.showGenericOverlayDialog && this.state.isCreateTemplateServiceCompleted && this.state.isExportProductsServiceCompleted?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleGenericDialogStatus.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	savePriceTemplates: (data) => dispatch(savePriceTemplates(data)),
	exportProducts: (payload, queryStringParams, callback) => dispatch(exportProducts(payload, queryStringParams, callback)),
	createPriceTemplate: (payload, callback) => dispatch(createPriceTemplate(payload, callback)),
	updatePriceTemplate: (payload, callback) => dispatch(updatePriceTemplate(payload, callback)),
	getMessages: (queryString, showLoader, callback) => dispatch(getMessages(queryString, showLoader, callback)),
});

CreateNewTemplate = connect(mapStateToProps, mapDispatchToProps)(CreateNewTemplate);
export default CreateNewTemplate;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Exports/createNewTemplate.js